const get = async (promise) =>
  promise.then(
    (data) => [null, data],
    (err) => [err, null]
  );

// eslint-disable-next-line import/prefer-default-export
export { get };
